import { render } from "./CommentItem.vue?vue&type=template&id=cd49c028&scoped=true"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"

import "./CommentItem.vue?vue&type=style&index=0&id=cd49c028&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd49c028"]])

export default __exports__